import React, { useEffect } from 'react';
import { Circle } from '@react-google-maps/api';
import { useSelector } from 'react-redux';
import { RootState } from '../../app/store';


export type MapCircleProps = {
    // center: { lat: number; lng: number };
    // radius: number; // in meters
    map: google.maps.Map;
    fitBounds?: boolean;
};


export const canDrawCircle = (agentData: any) => {
    return agentData && agentData.center && agentData.radius && agentData.radius > 0 && agentData.radius < 1000000;
}
export const MapCircle: React.FC<MapCircleProps> = ({
    // center,     // radius,
    map,
    fitBounds = true,
}) => {
    const agentDataGeo = useAgentData();
    useEffect(() => {
        if (fitBounds && map && canDrawCircle(agentDataGeo)) { 
            
            console.log('Fitting bounds for circle', agentDataGeo);
            const circle = new google.maps.Circle({
                ...agentDataGeo
            });
            map.fitBounds(circle.getBounds() as google.maps.LatLngBounds);
        }
   // }, [agentDataGeo, map, fitBounds]);
   }, [fitBounds, map, agentDataGeo?.center?.lat, agentDataGeo?.center?.lng, agentDataGeo?.radius]);

    if (!agentDataGeo) {
        return null; // or return a placeholder if needed
    }
    return (
        <Circle
            center={agentDataGeo.center}
            radius={agentDataGeo.radius}
            options={{
                strokeColor: '#FF0000',
                fillColor: '#FF0000',
                strokeOpacity: 0.8,
                strokeWeight: 2,
                fillOpacity: 0.35,
            }}
        />
    );
};


const GetLastAgentData = (state: any, funcionName: string = "show_on_map_area") => {
    const lastMutationKey = Object.keys(state.aiAnalytics.mutations || {})
        .filter((key) => state.aiAnalytics.mutations[key].endpointName.startsWith('askAgent'))
        .pop();
    if (!lastMutationKey)
        return undefined;
    const askAgentStatus = lastMutationKey
        ? state.aiAnalytics.mutations[lastMutationKey]?.status
        : undefined;
    if (!askAgentStatus)
        return undefined;


    if (askAgentStatus === "fulfilled" && lastMutationKey) {
        const askAgentMutation = state.aiAnalytics?.mutations[lastMutationKey];
       
        const askAgentResult = (askAgentMutation.data.askAgentResults ?? []).find((aar: any) => aar.function?.name === "show_on_map_area")
        const args = askAgentResult?.function?.arguments ? JSON.parse(askAgentResult.function?.arguments) : {};
        const agentData = askAgentResult?.data
        if (!agentData)
            return undefined;
        return {
              ...agentData,
            center: agentData?.center,
            //radius: agentData?.radius ?? 80467,//args?.radius?? 80467,
            args,
            // ...agentData?.userPins ? { userPins: agentData.userPins } : {},
            // ...agentData?.institutionPins ? { institutionPins: agentData.institutionPins } : {},
           
        }
    }
    return undefined;
}

export const useAgentData = (functionName?: string ) => {
    return useSelector((state: RootState) => {
        const aiSearchState = state.search.aiSearch;
        if (aiSearchState) {
            const agentData = GetLastAgentData(state, functionName??"show_on_map_area");
            return agentData
        }
        return undefined;
    });
};